var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.460938 4.18384C0.90416 3.77886 1.34568 3.37557 1.80424 2.95711C2.58798 3.70891 3.42158 4.50874 4.27691 5.32923C6.03489 3.6221 7.78945 1.91875 9.52441 0.234375C9.96763 0.655786 10.4006 1.06793 10.8456 1.49102C10.7974 1.54496 10.7599 1.593 10.7164 1.63472C9.02706 3.27949 7.3377 4.9251 5.64536 6.56733C4.97584 7.21715 4.135 7.33683 3.34955 6.89393C3.20934 6.81512 3.08021 6.71019 2.96344 6.59936C2.1503 5.82565 1.34142 5.04688 0.531683 4.26938C0.512079 4.25084 0.496736 4.22724 0.460938 4.18384Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedAvatar);
export default __webpack_public_path__ + "static/media/selectedAvatar.d2961232c2de3e09969e25b87e6f5db6.svg";
export { ForwardRef as ReactComponent };